import { useMutation } from '@apollo/client/react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { GQL_ADD_USERS_TO_GROUP, GQL_REMOVE_USERS_FROM_GROUP } from '~/gql/groups/groups'

/**
 * Ajoute ou retire d'un coup les comptes cochés du groupe choisi dans la barre
 * d'actions groupées. `onApplied` vide la sélection et rafraîchit ce qui a
 * bougé : la liste, et les compteurs de membres du filtre par groupe.
 */
export function useBulkGroupAssignment(selectedIds: ReadonlySet<string>, onApplied: () => Promise<unknown>) {
  const { t } = useTranslation()
  const [groupId, setGroupId] = useState('')
  const [addUsersToGroup] = useMutation(GQL_ADD_USERS_TO_GROUP)
  const [removeUsersFromGroup] = useMutation(GQL_REMOVE_USERS_FROM_GROUP)

  const apply = async (action: 'add' | 'remove') => {
    if (!groupId || selectedIds.size === 0) return
    const variables = { groupId, userIds: [...selectedIds] }
    try {
      if (action === 'add') await addUsersToGroup({ variables })
      else await removeUsersFromGroup({ variables })
      toast.success(t(action === 'add' ? 'groups.bulk.added' : 'groups.bulk.removed'))
      await onApplied()
    } catch {
      toast.error(t('groups.bulk.failed'))
    }
  }

  return { groupId, setGroupId, apply }
}
